import { useEffect, useState } from "react";
import SideBar from "../components/sideBar";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import translateText, {
  LanguageDirection,
  currentLanguage,
} from "../signals/language.signal";
import { cartProductData } from "../signals/orderData.signal";
import { getStorage, setStorage } from "../helpers/helper";
import DeleteIcon from "@mui/icons-material/Delete";
// import cartEmpty from "../assets/cartEmpty.gif";
import {
  logClientMobileNumber,
  logClientNumber,
  signalPagePath,
} from "../signals/login.signal";
import { Link } from "react-router-dom";
import LazyImage from "../components/LazyImage";
const Card = () => {
  const [total, setTotal] = useState("0");
  const [Loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    cartProductData.value = [];
    cartProductData.value = getStorage("cartData");
    var countToal = 0;
    cartProductData.value.forEach((element) => {
      countToal += element.QUANTITY * element.PRICE;
    });
    setTotal(countToal);
  }, []);

  const handleDelete = async (itemId) => {
    cartProductData.value = cartProductData.value.filter(
      (item) => item.id !== itemId
    );
    setStorage("cartData", cartProductData.value);
  };
  const handleSubmit = async () => {
    setLoading(true);
    setDisabled(true);
    try {
      const username = "Guthmi";
      const password = "ApiCal2023@_2115&";
      const basicAuth = btoa(username + ":" + password);

      const response = await fetch(
        "https://alguthmi.co/API/B2BAppAPI/insertHOrder.php",
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${basicAuth}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            CLICODE: logClientNumber.value,
            MOBLILENO: logClientMobileNumber.value,
          }),
        }
      );

      if (response.ok) {
        const jsonResponse = await response.json();
        for (const element of cartProductData.value) {
          try {
            const response = await fetch(
              "https://alguthmi.co/API/B2BAppAPI/insertDOrder.php",
              {
                method: "POST",
                headers: {
                  Authorization: `Basic ${basicAuth}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  CLICODE: logClientNumber.value,
                  MOBLILENO: logClientMobileNumber.value,
                  TRANNO: jsonResponse.TRANNO,
                  ARTCODE: element.SQU,
                  QTY: element.QUANTITY,
                  DISCOUNT: 0,
                  WHS: element.WAREHOUSEID,
                  NOTES: element.NOTE,
                }),
              }
            );

            if (response.ok) {
              const jsonResponse = await response.json();
            } else {
              console.error("Detail Insertion failed:", await response.text());
            }
          } catch (error) {
            console.error("Error inserting detail:", error);
          }
        }
        cartProductData.value = [];
        setStorage("cartData", cartProductData.value);
      } else {
        console.error("Header Insertion failed:", await response.text());
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  return (
    <div
      id="card"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "CartTitle")}
      />

      {cartProductData.value ? (
        cartProductData.value.length != 0 ? (
          <>
            <div className="container pt-3 align-items-sm-center loginContaner  d-flex justify-content-center w-100 flex-md-row flex-wrap">
              <div className="row ">
                <h5 className="mt-3">Order items</h5>
                {cartProductData.value.map((element) => {
                  return (
                    <div
                      key={element.id}
                      className="col-12 col-lg-3 "
                      dir={LanguageDirection.value}
                    >
                      <div className=" mb-3 position-relative loginContaner bg-white   shadow rounded-3 d-flex justify-content-between align-items-center ">
                        <div
                          className={
                            LanguageDirection.value == "rtl"
                              ? "bg-white position-absolute top-0 start-0 p-1 border btn shadow-sm m-1"
                              : "bg-white position-absolute top-0 end-0 p-1 border btn shadow-sm m-1"
                          }
                          onClick={() => {
                            handleDelete(element.id);
                          }}
                        >
                          <DeleteIcon
                            sx={{
                              cursor: "pointer",
                              fill: "#CA1F00",
                              fontSize: 23,
                            }}
                          />
                        </div>
                        <div className=" border  w-100 rounded-3 bg-secondary-subtle">
                          <LazyImage
                            src={element.IMGURL}
                            alt={element.COLLECTIONENAME}
                            height="100%"
                            width="100%"
                            style={{
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                            className="p-0 rounded-3"
                          />
                        </div>
                        <div className="w-100 mt-3 p-2">
                          <div className="mb-1 w-100  rounded-3 ">
                            <p
                              className="form-label m-0"
                              style={{ fontSize: 12, fontWeight: "700" }}
                            >
                              {element.COLLECTIONANAME}
                            </p>
                            <hr className="m-0" />
                          </div>
                          <table
                            cellPadding={0}
                            cellSpacing={0}
                            className="tayble  w-100"
                          >
                            <tbody>
                              <tr>
                                <td valign="top" className="p-0">
                                  <div
                                    style={{ fontSize: 10, fontWeight: "700" }}
                                  >
                                    {translateText(
                                      currentLanguage.value,
                                      "Code"
                                    )}
                                  </div>
                                </td>
                                <td className="p-0">
                                  <div
                                    className={
                                      LanguageDirection.value == "rtl"
                                        ? "text-start"
                                        : "text-end"
                                    }
                                    style={{ fontSize: 10 }}
                                  >
                                    {" "}
                                    {element.SQU}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td valign="top" className="p-0">
                                  <div
                                    style={{ fontSize: 10, fontWeight: "700" }}
                                  >
                                    {translateText(
                                      currentLanguage.value,
                                      "Quantity"
                                    )}
                                  </div>
                                </td>
                                <td className="p-0">
                                  <div
                                    className={
                                      LanguageDirection.value == "rtl"
                                        ? "text-start"
                                        : "text-end"
                                    }
                                    style={{ fontSize: 10 }}
                                  >
                                    {" "}
                                    {element.QUANTITY}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td valign="top" className="p-0">
                                  <div
                                    style={{ fontSize: 10, fontWeight: "700" }}
                                  >
                                    {translateText(
                                      currentLanguage.value,
                                      "Price"
                                    )}
                                  </div>
                                </td>
                                <td className="p-0">
                                  <div
                                    className={
                                      LanguageDirection.value == "rtl"
                                        ? "text-start"
                                        : "text-end"
                                    }
                                    style={{ fontSize: 10 }}
                                  >
                                    {" "}
                                    {element.PRICE}{" "}
                                    {translateText(
                                      currentLanguage.value,
                                      "Currency"
                                    )}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <td valign="top" className="p-0">
                                  <div
                                    style={{ fontSize: 10, fontWeight: "700" }}
                                  >
                                    {translateText(
                                      currentLanguage.value,
                                      "total"
                                    )}
                                  </div>
                                </td>
                                <td className="p-0">
                                  <div
                                    className={
                                      LanguageDirection.value == "rtl"
                                        ? "text-start"
                                        : "text-end"
                                    }
                                    style={{ fontSize: 10 }}
                                  >
                                    {" "}
                                    {element.QUANTITY * element.PRICE}{" "}
                                    {translateText(
                                      currentLanguage.value,
                                      "Currency"
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className=" position-relative loginContaner p-3 flex-row w-100 rounded-3 d-md-flex  justify-content-between align-items-center">
                <div className="d-flex justify-content-between flex-wrap flex-row">
                  <h6> {translateText(currentLanguage.value, "total")}</h6>
                  <h6>{total}</h6>
                </div>
                <Link
                  to={signalPagePath.value ? "/Checkout" : "/"}
                  className="btn btn-primary border pe-3 ps-3 w-100"
                  style={{
                    background: primary.value,
                    color: primaryFount.value,
                  }}
                >
                  {translateText(currentLanguage.value, "Ckeckout")}
                </Link>
              </div>
            </div>
          </>
        ) : (
          <div className="d-flex justify-content-center flex-column align-items-center">
            {/* <LazyImage
              src={cartEmpty}
              alt="Empty"
              style={{
                objectFit: "cover",
                objectPosition: "center",
              }}
              className="w-100"
            /> */}
            <h5>{translateText(currentLanguage.value, "NoCartItem")}</h5>
          </div>
        )
      ) : (
        <div className="d-flex justify-content-center flex-column align-items-center">
          {/* <LazyImage
            src={cartEmpty}
            alt="Empty"
            style={{
              objectFit: "cover",
              objectPosition: "center",
            }}
            className="w-100"
          /> */}
          <h5>{translateText(currentLanguage.value, "NoCartItem")}</h5>
        </div>
      )}
    </div>
  );
};

export default Card;
